export enum Language {
  German = 'de_DE',
  English = 'en_US',
  French = 'fr_FR'
}
